import { render, staticRenderFns } from "./moduleDetail.vue?vue&type=template&id=cda536f0&scoped=true&"
import script from "./moduleDetail.vue?vue&type=script&lang=js&"
export * from "./moduleDetail.vue?vue&type=script&lang=js&"
import style0 from "./moduleDetail.vue?vue&type=style&index=0&id=cda536f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda536f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAlert,VBtn,VIcon,VProgressLinear})
